<template>
  <div>
    <!-- <Row style="background: #e8e8e8;  width: 100%;  margin: 0 auto;  height: auto;  padding:5px;">
      <Col span="6" offset="18">
        <ul class="ul1">
          <li @click="goFirst" class="li1" v-if="sessionInfoGetter.isLogin!='login'">注册</li>
          <li @click="goSecond" class="li1" v-if="sessionInfoGetter.isLogin!='login'">登录</li>
          <li @click="goHome" class="li1" v-if="sessionInfoGetter.isLogin=='login'">{{userName}}</li>
          <li @click="logout" class="li1" v-if="sessionInfoGetter.isLogin=='login'">退出</li>
        </ul>
      </Col>
    </Row> -->
    <div style="position: fixed;
	    top: 0px;
	    left: 0px;
	    display: flex;
	    justify-content: space-around;
	    align-items: center;
	    z-index: 99;
	    right: 0px;">
      <Row style="background: linear-gradient(-154deg, #20202C, #20202C); width: 100%;  margin: 0 ;  height: 110px;  padding:15px; ">
        <Col
          span="3"
          offset="-2"
        >
        <router-link
          to="/indexPage"
          @click.native="change"
        ><img
            :src="img"
            width="120px"
            height="80px"
            alt="123"
          ></router-link>
        </Col>
        <Col
          span="14"
          offset="3"
          style="margin-top:10px"
        >
        <ul class=" sd ul1">
          <li
            class="li1"
            v-for="(item, index) in daohang"
            :key="item.value"
            @click="changeBgc(item.path, index)"
            :class="{ 'bgor': changebgor == index }"
          >
            {{ item.label }}
          </li>
        </ul>
        </Col> 
      </Row>
    </div>
	<div class="connectMain">
	<content1></content1>
 
      <Row>
        <Col> 
        <div class="connectBanner">
          <div class="backImg">
            <img
              :src="img16"
              width="100%" 
			  height="420px"
            ></br>
          </div>

          <div class="contentBox ofhd">

            <Row :gutter="5">
              <Col
                span="5"
                align="left"
                style="color: white;padding-left: 11.5px;padding-right: 12.5px;margin-bottom: 50px;font-size: 20px;margin-left: 30px;"
              >
				<p>
					<span class="sign">|</span><span>联系我们</span>
				</p>
              </Col>
            </Row>

            <Row :gutter="0">
              <Col
                span="5"
                align="left"
                style="color: rgb(251, 197, 75);padding-left: 12.5px;padding-right: 12.5px;margin-bottom: 40px;font-size: 20px;margin-left: 35px;"
              >
              <span class="footLable">产品</span>
              </Col>
              <Col
                span="5"
                align="left"
                style="color: rgb(251, 197, 75);padding-left: 12.5px;padding-right: 12.5px;margin-bottom: 40px;font-size: 20px;margin-left: -23px;"
              >
              <span class="footLable">快速入口</span>
              </Col>
              <Col
                span="5"
                align="left"
                style="color: rgb(251, 197, 75);padding-left: 12.5px;padding-right: 12.5px;margin-bottom: 40px;font-size: 20px;margin-left: -15px;"
              >
              <span class="footLable">关于我们</span>
              </Col>
              <Col
                span="5"
                align="left"
                style="color: rgb(251, 197, 75);padding-left: 12.5px;padding-right: 12.5px;margin-bottom: 40px;font-size: 20px;margin-left: -23px;"
              >
              <span class="footLable">联系方式</span>
              </Col>

            </Row> 

            <Row
              :gutter="-90"
              type="none"
              :key="index"
            >
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/gasData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >天然气大数据产品</span>
              </router-link></Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/gasData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >天然气产品试用</span>
              </router-link></Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/newsData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >泽达媒体专栏</span>
              </router-link></Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/gasData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >北龙泽达（北京）数据科技有限公司</span>
              </router-link></Col>

              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/carData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >汽车大数据产品</span>
              </router-link></Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              > 
              <span
                style="color:darkgray;line-height:25px;font-size:14px;"
                target="_blank"
              >车况查询</span> 
              </Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/connectData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >合作单位</span>
              </router-link></Col> 		  
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <span
                style="color:darkgray;line-height:25px;font-size:14px;"
                target="_blank"
              >企业邮箱:blzd@zedata.cn</span>
              </Col>

              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/voiceData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >声学领域工程</span>
              </router-link></Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <span
                style="color:darkgray;line-height:25px;font-size:14px;"
                target="_blank"
              >&nbsp;</span>
              </Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/connectData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >公司简介</span>
              </router-link></Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <span
                style="color:darkgray;line-height:25px;font-size:14px;"
                target="_blank"
              >公司地址:佑安国际大厦4层409</span>
              </Col>

              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/remoteDigData"><span
                style="color:darkgray;line-height:25px;font-size:14px;"
                target="_blank"
              >遥感大数据</span></router-link>
              </Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <span
                style="color:darkgray;line-height:25px;font-size:14px;"
                target="_blank"
              >&nbsp;</span>
              </Col>
              <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <router-link to="/connectData"><span
                  style="color:darkgray;line-height:25px;font-size:14px;"
                  target="_blank"
                >人才招聘</span>
              </router-link></Col>

              <!-- <Col
                span="5"
                align="left"
                style="color:darkgray;line-height:25px;font-size:14px;"
              >
              <a
                style="color: darkgray;line-height: 25px;font-size: 14px;position: relative;bottom: -210px;left: 150%;"
                href="https://beian.miit.gov.cn"
                target="_blank"
              >京ICP备12039065号-1</a>
              </Col> -->
            </Row> 


          </div>
			<div class="contentBox-ICP">
				<a
					style="color: darkgray;line-height: 25px;font-size: 14px;"
					href="https://beian.miit.gov.cn"
					target="_blank"
				>京ICP备12039065号-1</a>
			</div>
		  

        </div>
        </Col>

      </Row>
    </div> 
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import content1 from "./content/content1";
export default {
  components: {
    content1,
  },
  data() {
    return {
      changebgor: 0,
      img: "../../../static/logo.webp",
      img21: "../../../static/21.png",
      img16: "../../../../static/officeImg/index/footer.webp",
      //导航
      daohang: [
        { path: "/indexPage", label: "首页" },
        { path: "/carData", label: "汽车大数据" },
        { path: "/voiceData", label: "声学领域工程" },
        { path: "/gasData", label: "天然气大数据" },
        {path:'/remoteDigData',label:'遥感大数据'},
        { path: "/newsData", label: "媒体资讯" },
        { path: "/connectData", label: "联系我们" },
        // {path:'/applyData',label:'申请合作'},
        // {path:'/newsDataDetails',label:'媒体详细'},
      ],
      outfit2: [],
      other: ["关于我们", "帮助我们", "帮助中心", "用户中心", "网站地图"],
    };
  },
  computed: {
    ...mapGetters(["sessionInfoGetter"]),
    userName() {
      if (this.sessionInfoGetter.userModel != null) {
        let userModel = JSON.parse(this.sessionInfoGetter.userModel);
        return userModel.userName;
      }
    },
  },
  // 生命周期
  mounted() { 
    if (this.userName != null && this.userName != "") { 
      this.checkUser();
    }
    this.localtoSession();
    if (this.$route.query.item) {
      this.changebgor = this.$route.query.item;
    } else {
      this.changebgor = 0;
    } 
	setTimeout(()=>{
		// 兼容IE
		if(document.all) {
			document.getElementById("qqLink").click();
		}
		// 兼容其它浏览器
		else {
			var e = document.createEvent("MouseEvents");
			e.initEvent("click", true, true);
			document.getElementById("qqLink").dispatchEvent(e);
		}
	},2000); 

  },
  methods: {
    change: function () {
      this.changebgor = 0;
    }, 
    goFirst: function () {
      this.$router.push({ path: "/register" });
    },
    goSecond: function () {
      this.$router.push({ path: "/login" });
    },
    goHome: function () {
      let userModel = JSON.parse(this.sessionInfoGetter.userModel);
      if (userModel.type == null) {
        this.$router.push({ path: "/success" });
      } else {
        window.location.href = "http://uc.office.jinmajia.com/#/home";
      }
    },
    changeBgc(item, index) {
      this.changebgor = index;
      if (item == "/addItem") {
        window.location.href =
          "http://uc.office.jinmajia.com/#/project-manage/new-project";
      } else if (item == "/addInvestment") {
        window.location.href =
          "http://uc.office.jinmajia.com/#/investment/new-investment-demand";
      } else {
        this.$router.push({ path: item, query: { item: index } });
      }
    },
    logout: function () { 
      this.$store.commit("LOGIN_OUT");
      this.setCookie("token", "", -1);
      this.setCookie("mobile", "", -1);
      localStorage.clear();
      sessionStorage.clear();
      location.reload();
    },
    localtoSession: function () {
      if (localStorage.jmjInfo != "" && localStorage.jmjInfo != undefined) {
        this.$store.commit("setSessionInfo", JSON.parse(localStorage.jmjInfo));
      }
    },
    //读取cookie
    getCookie(name) {
      let arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
      } else {
        return null;
      }
    },
    //设置cookie
    setCookie: function (cname, cvalue, exhours) {
      var str = cname + "=" + escape(cvalue);
      if (exhours > 0) {
        var d = new Date();
        d.setTime(d.getTime() + exhours * 60 * 60 * 1000);
        //var expires = "expires=" + d.toUTCString();
        str += "; expires=" + d.toGMTString();
      }

      document.cookie = str + ";domain=.jinmajia.com;path=/;";
      console.info(str);
    },
    checkUser: function () {
      let token = this.getCookie("token");
      let mobile = this.getCookie("mobile");
      //alert(token);
      if (token == null || token == "") {
        localStorage.clear();
        sessionStorage.clear();
        location.reload();
      } else {
        protocol.param_getUser.data = {};
        http
          .get(protocol.param_getUser, protocol.param_getUser.data)
          .then((response) => {
            if (response.data.code == "401") {
              this.setCookie("token", "", 0);
              this.setCookie("mobile", "", 0);
              localStorage.clear();
              sessionStorage.clear();
              //location.reload();
              console.log("好像已离线呢~");
            } else {
              console.log("好像在线呢~");
            }
          });
      }
    },
  },
};
</script>
<style scoped>
.backg {
  background-color: lavender;
}
.li1 {
  float: left;
  margin-left: 50px;
  cursor: pointer;
  padding: 5px;
  color: white;
  height: 40px;
} 
.bgor {
    border-bottom-color: white;
}
.connectBanner .contentBox {
  position: absolute;
  bottom: 0;
  width: 1800px;
  height: 400px;
  text-align: center;
  padding: 15px;
  /* top: 70px; */
  top: 20px;
  left: 250px; 
}
.sign{
	margin-right: 10px;
}
.ul1 {
  list-style-type: none;
}
.sd {
  margin-top: 8px;
  font-size: 18px;
}
.phone {
  position: absolute;
  right: 10px;
  top: 40px;
}
.other {
  width: 200px;
  color: white;
}
.contentBox-ICP{
	position: absolute; 
    bottom: 10px; 
	width: 100%;
	margin: 0 auto;   
    text-align: center; 
}
/* 内容区 */
.connectMain{
	width: 100%;
	/* height: auto; */
	margin-top: 110px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue